import React from 'react';

type IconProps = React.SVGProps<SVGSVGElement>;

const RefreshIcon: React.FC<IconProps> = (props) => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.7086 5.79157C14.0101 5.0868 13.1622 4.54792 12.2276 4.21473C11.2929 3.88155 10.2953 3.76257 9.30855 3.86657C6.25022 4.17491 3.73355 6.65824 3.39189 9.71658C2.93355 13.7582 6.05855 17.1666 10.0002 17.1666C11.2586 17.1666 12.4912 16.8095 13.5548 16.1369C14.6184 15.4642 15.4692 14.5036 16.0086 13.3666C16.2752 12.8082 15.8752 12.1666 15.2586 12.1666C14.9502 12.1666 14.6586 12.3332 14.5252 12.6082C14.0414 13.6491 13.2139 14.4916 12.1818 14.9939C11.1498 15.4963 9.97622 15.6279 8.85855 15.3666C7.00855 14.9582 5.51689 13.4499 5.12522 11.5999C4.96058 10.8685 4.96249 10.1094 5.1308 9.37874C5.29911 8.64813 5.62952 7.9647 6.0976 7.37901C6.56567 6.79332 7.15942 6.32035 7.83495 5.99509C8.51047 5.66983 9.25047 5.5006 10.0002 5.49991C11.3836 5.49991 12.6169 6.07491 13.5169 6.98324L12.2586 8.24157C11.7336 8.76657 12.1002 9.66657 12.8419 9.66657H15.8336C16.2919 9.66657 16.6669 9.29157 16.6669 8.83324V5.84157C16.6669 5.09991 15.7669 4.72491 15.2419 5.24991L14.7086 5.79157Z" fill="black"/>
</svg>



);

export default RefreshIcon;


